// @flow

import smoothscroll from 'smoothscroll-polyfill'

import { logger } from '.'

smoothscroll.polyfill()

export function scrollLimit (element: HTMLElement): number {
  return Math.max(element.scrollHeight, element.offsetHeight, element.clientHeight, element.scrollHeight, element.offsetHeight) - element.offsetHeight
}

export function scrollToLastMessage (): void {
  logger.info('Scrolling to last message...')
  const chatBody = document.querySelector('.chat-scroll-body')
  if (chatBody) {
    // This looks like a Chrome bug
    // If we immediately scroll to the bottom smooth scrolling behavior does not work any more
    chatBody.scrollTo({
      top: Math.max(0, chatBody.scrollHeight - 1000),
      behavior: 'auto'
    })
    chatBody.scrollTo({
      top: chatBody.scrollHeight,
      behavior: 'smooth'
    })
  }
}

export function scrollToFirstNewMessageOrTypingIndicator (): void {
  logger.info('Scrolling to first new message or typing indicator...')

  const firstNewMessage = document.getElementsByClassName('new-message')
  if (firstNewMessage.length > 0) {
    firstNewMessage[0].scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  } else {
    const typingIndicator = document.getElementsByClassName('typing-indicator')
    if (typingIndicator.length > 0) {
      typingIndicator[typingIndicator.length - 1].scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    } else {
      scrollToLastMessage()
    }
  }
}

export function scrollWindowToElementsTop (element: Element): void {
  const top = element.getBoundingClientRect().top + window.scrollY
  scrollToElementsTop(window, top)
}

export function scrollToElementsTop (element: Element, top: number): void {
  element.scrollTo({ top, behavior: 'smooth' })
}
